import React from "react";
import PropTypes from "prop-types";
import {Modal} from 'react-bootstrap'
import {confirmable, createConfirmation} from 'react-confirm'
import '../../style/component/modal/Media.css'
import SVGraphics from "../../assets/SVGraphics";

class ImageModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            url: null,
            isErr: false
        }
    }


    render() {
        let {
            url,
            show,
            proceed
        } = this.props;
        return (
            <Modal
                size="lg"
                show={show}
                centered={true}
                onHide={() => proceed()}
                dialogClassName={'image-media-dialog media-dialog'}
                contentClassName={'image-media-content media-content'}
                backdrop={false}
                keyboard={true}
                aria-labelledby="example-modal-sizes-title-sm"
            >
                <div className={'media-close-btn-container modal-close pointer'} onClick={() => proceed()}>
                    <SVGraphics svgname={'close'} className={'modal-close-btn'}/>
                </div>
                {/*<Modal.Header className={'image-media-header media-header'} closeButton/>*/}
                <Modal.Body className={'image-media-body media-body'}>
                    <img className={'modal-image-media modal-media'} src={url}/>
                </Modal.Body>
            </Modal>
        );
    }
}

ImageModal.propTypes = {
    show: PropTypes.bool,
    url: PropTypes.string
};

export default function MakeImage({url: url = ''}) {
    return createConfirmation(confirmable(ImageModal))({
        url
    });
}
